<template>
  <div class="sidebar" v-if="!collapse">
    <el-menu
      mode="vertical"
      default-active="0"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      @select="handleSelect"
    >
      <div class="title">Anima Admin</div>
      <component
        v-for="(item, itemIndex) in menuItems"
        :is="item.submenus ? 'el-submenu' : 'el-menu-item'"
        :key="itemIndex"
        :index="String(itemIndex)"
      >
        <template v-if="item.submenus" #title>
          <icon v-if="item.icon" :type="item.icon" />
          {{ item.name }}
        </template>

        <el-menu-item-group v-if="item.submenus">
          <el-menu-item
            v-for="(submenu, submenuIndex) in item.submenus"
            :key="submenuIndex"
            :index="`${itemIndex}-${submenuIndex + 1}`"
            @click="handleSubmenuCLick(submenu.route)"
          >
            {{ submenu.name }}
          </el-menu-item>
        </el-menu-item-group>

        <span v-if="!item.submenus">
          <icon v-if="item.icon" :type="item.icon" />
          {{ item.name }}
        </span>
      </component>
    </el-menu>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";

const menuItems = [
  //{ name: "Dashboard", icon: "el-icon-data-line", route: "/dashboard" },
  { name: "Customer Success", icon: "el-icon-user", route: "/customers" },
  { name: "Product", icon: "el-icon-shopping-bag-1", route: "/product" },
  { name: "Marketing", icon: "el-icon-price-tag", route: "/marketing" },
  { name: "My Account", icon: "el-icon-user", route: "/account" },
  { name: "Enterprise", icon: "el-icon-office-building", route: "/enterprise"},
  { name: "Sales", icon: "el-icon-money", route: "/sales" },
  {
    name: "DevOps",
    icon: "el-icon-cloudy",
    submenus: [
      { name: "Instant Rollback", route: "/devops/rollback" },
      { name: "Canary Management", route: "/devops/management" },
    ],
  },
  // { name: 'Business Inteligence', icon: 'el-icon-s-data', route: '/bi' },
  // { name: 'Tech', icon: 'el-icon-cpu', route: '/tech' },
];

export default {
  props: {
    collapse: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Icon,
  },
  data() {
    return {
      menuItems,
    };
  },
  methods: {
    handleSelect(index) {
      const { route } = this.menuItems[index];
      this.$router.push(route).catch(() => {});
      // this.$trackEvent('admin.sidebar.navigation', { route });
    },

    handleSubmenuCLick(menuRoute) {
      this.$router.push(menuRoute).catch(() => {});
    },
  },
};
</script>

<style scoped>
.sidebar {
  display: flex;
}
.title {
  width: 100%;
  text-align: center;
  color: white;
  margin-top: 32px;
  margin-bottom: 16px;
}
</style>
